(() => {
  const hamburger = document.querySelector('.header__hamburger');
  if (!hamburger) return;

  const setOpen = (open) => {
    document.body.classList.toggle('menu-open', open);
    hamburger.setAttribute('aria-expanded', String(open));
    hamburger.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
  };

  hamburger.addEventListener('click', () => {
    setOpen(!document.body.classList.contains('menu-open'));
  });

  document.querySelectorAll('.header__menu-link').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  window.matchMedia('(min-width: 1024px)').addEventListener('change', ({ matches }) => {
    if (matches) setOpen(false);
  });
})();
